import { createMiddleware, createStart } from "@tanstack/react-start";
import { setResponseHeader } from "@tanstack/react-start/server";

const legacyUserPattern = /^\/user\/([^/]+)(\/.*)?$/;

const legacyUserRedirect = createMiddleware().server(
  async ({ next, request }) => {
    const url = new URL(request.url);
    const match = url.pathname.match(legacyUserPattern);
    if (match) {
      const username = match[1];
      const rest = match[2] || "";
      return new Response(null, {
        headers: { Location: `/@${username}${rest}` },
        status: 301,
      });
    }
    return await next();
  }
);

const robotsTag = createMiddleware().server(async ({ next }) => {
  const isProd = process.env.SENTRY_ENV === "production";
  setResponseHeader("X-Robots-Tag", isProd ? "all" : "none");
  return await next();
});

export const startInstance = createStart(() => ({
  requestMiddleware: [legacyUserRedirect, robotsTag],
}));
